
const freemiumUnlocklist = [
  /^\/accounting\/driverSettlement(\/.*)?$/,
  /^\/accounting\/quickbooks(\/.*)?$/,
  /^\/accounting\/accountingInvoice(\/.*)?$/,
  /^\/accounting\/expense(\/.*)?$/,
  /^\/accounting\/ifta(\/.*)?$/,
  /^\/accounting(\/.*)?$/,
  /^\/permissionSettings(\/.*)?$/,
];

function matchFreemiumUnlocklistlist(path) {
  const list = freemiumUnlocklist.filter(i => !!i);
  return list.some(item => item.test(path))
}
export default matchFreemiumUnlocklistlist;